import { DatastoreInterface } from '@freelancer/datastore/core';
import { SiteStats } from './site-stats.model';
import { SiteStatsCollection } from './site-stats.types';

interface GenerateSiteStatsOptions {
  readonly userId: number;
}

export async function createSiteStats(
  datastore: DatastoreInterface,
  options: GenerateSiteStatsOptions,
) {
  const object = generateSiteStatsObject(options);
  await datastore.createRawDocument<SiteStatsCollection>('siteStats', object);
  return object;
}

function generateSiteStatsObject({
  userId,
}: GenerateSiteStatsOptions): SiteStats {
  return {
    id: userId.toString(),
    projectCount: 4864009,
    projectCountPerDay: 3021,
    userCount: 30874142,
    userCountPerDay: 1780,
  };
}
